import { DeviceType, NavLayout } from '../enum/EnumRepository';
import { useDeviceStore } from '../store/deviceStore';
import { useSettingStore } from '../store/settingStore';
import { ENABLE_FIXED_NAV_LAYOUT, resolveNavLayout } from '../util/navLayout';

export const useNavLayout = (): NavLayout => {
  const navLayout = useSettingStore((s) => s.setting?.navLayout);
  const deviceType = useDeviceStore((s) => s.deviceType);

  if (
    !ENABLE_FIXED_NAV_LAYOUT ||
    deviceType === DeviceType.MOBILE ||
    deviceType === DeviceType.TABLET
  ) {
    return NavLayout.FOLD;
  }

  return resolveNavLayout(navLayout);
};
